import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {RecentRequisitionViewModel} from '../../../../../shared/models/ocl';
import {PWADetectorService} from '../../../../../shared/services/general';
import {RecentRequisitionService} from '../../../../shared/services/recent-requisition.service';

@Component({
  selector: 'app-recent-requisitions',
  templateUrl: './recent-requisitions.component.html',
  styleUrls: ['./recent-requisitions.component.scss'],
})
export class RecentRequisitionsComponent implements OnInit {
  public recentRequisitions: RecentRequisitionViewModel[] = [];

  constructor(private recentRequisitionService: RecentRequisitionService, private pwaDetectorService: PWADetectorService, private router: Router) {
  }

  public ngOnInit() {
    this.recentRequisitions = this.recentRequisitionService.getRecentRequisitions();
    // @ts-ignore
    this.recentRequisitions.sort((a, b) => b.id - a.id);
  }

  public lastRequisitionBtnClicked() {
    const lastId = this.recentRequisitions[0].id;
    if (this.pwaDetectorService.isPWA()) {
      this.router.navigate(['/secured/requisitions/create', {id: lastId}]).then();
    } else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/secured/requisitions/create', {id: lastId}]),
      );
      window.open(url, '_blank');
    }
  }

  public rowClick(e: any) {
    const lastId = this.recentRequisitions[0].id;
    if (this.pwaDetectorService.isPWA()) {
      this.router.navigate(['/secured/requisitions/create', {id: lastId}]).then();
    } else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/secured/requisitions/create', {id: e.data.id}]),
      );
      window.open(url, '_blank');
    }
  }
}
